var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.theme.tabs,
    attrs: {
      "data-count": _vm.tabsCount
    }
  }, [_vm._l((_vm.tabs), function(tab, link) {
    return _c('div', {
      key: link,
      class: _vm.tabClasses(link)
    }, [(tab.active) ? _c('div', {
      directives: [{
        name: "ripple",
        rawName: "v-ripple",
        value: (_vm.rippleColor),
        expression: "rippleColor"
      }],
      class: _vm.theme.tabLabel,
      on: {
        "click": function($event) {
          _vm.handleClick(link)
        }
      }
    }, [_vm._v("\n            " + _vm._s(tab.label) + "\n        ")]) : _c('div', {
      class: _vm.theme.tabLabel
    }, [_vm._v("\n            " + _vm._s(tab.label) + "\n        ")])])
  }), _vm._v(" "), _c('div', {
    class: _vm.theme.slide
  })], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0929fdfd","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/baseComponents/components/Tabs/Tabs.vue
// module id = 605
// module chunks = 0